<agm-map [latitude]="depart.lat" [longitude]="depart.lng" [className]="imageMode? 'image-mode' : ''">
    <agm-direction *ngIf="this.dir" [origin]="this.dir.origin" [destination]="this.dir.destination">
    </agm-direction>
</agm-map>